import { Injectable } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ScreenService {
    private isMobileSubject = new BehaviorSubject<number>(0); // Valor inicial
    isMobile$ = this.isMobileSubject.asObservable();

    constructor(private breakpointObserver: BreakpointObserver) {
        // Solo se ejecuta en el cliente (para evitar problemas en SSR)
        if (typeof window !== 'undefined') {
            this.breakpointObserver.observe(["(min-width: 770px)"]).subscribe((state: BreakpointState) => {
                if (state.matches) {
                    this.isMobileSubject.next(1); // Desktop
                } else {
                    this.isMobileSubject.next(2); // Mobile
                }
            });
        }
    }
}
